import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function get_scam_reports(params = {}) {
  return request({
    url: global.endpoint.SCAM_REPORTS,
    method: "get",
    params
  });
}

async function delete_scam_report(id) {
  return request({
    url: `${global.endpoint.SCAM_REPORTS}/${id}`,
    method: "delete",
  });
}

async function search_identity(text) {
  return request({
    url: `${global.endpoint.COMPANY_SEARCH_PUBLIC}?kw=${text}`,
    method: "get",
  });
}

async function create_scam_report(data = {}) {
  return request({
    url: global.endpoint.SCAM_REPORTS,
    method: "post",
    data
  });
}

async function get_reports_is_anonymous(params = {}) {
  return request({
    url: global.endpoint.SCAM_REPORTS_IS_ANONYMOUS,
    method: "get",
    params
  });
}

async function toggle_reports_is_anonymous(data = { is_anonymous: false }) {
  return request({
    url: global.endpoint.SCAM_REPORTS_IS_ANONYMOUS,
    method: "put",
    data
  });
}

export default {
  get_scam_reports,
  delete_scam_report,
  search_identity,
  create_scam_report,
  get_reports_is_anonymous,
  toggle_reports_is_anonymous
};
